import {
  WcgToastBoxShadow,
  WcgToastConfig,
  WcgToastPanelSize,
} from '@wcg/frontend-framework';
import { ERM_ICONS_ENUM } from '@erm/cluster';

/**
 * Fallback copy for the pre-redesign response, which carries no document type and no assignee —
 * see [[RequestDocumentResult]]. It also skips the collaboration-hub sentence, since a flag-off
 * org has no hub for the to-do to land in.
 */
export const REQUEST_DOCUMENT_TOAST_FALLBACK = 'We requested the document.';

/** Success-toast styling for the request-document flow; callers only need to supply `data`. */
export const WCG_SUCCESS_TOAST_CONFIG: Omit<WcgToastConfig, 'data'> = {
  duration: 5000,
  height: WcgToastPanelSize.XXLarge,
  width: WcgToastPanelSize.XXXLarge,
  toastType: 'success',
  panelClass: ['p-6!', 'gap-6!'],
  toastMessageClass: 'body-large mr-1!',
  icon: ERM_ICONS_ENUM.CHECK_CIRCLE_FILLED,
  iconPosition: 'front',
  horizontalPosition: 'end',
  boxShadow: WcgToastBoxShadow.XLarge,
};

/** Confirmation copy after an external user uploads a requested document. */
const MAX_UPLOAD_RECEIPT_DOCUMENT_NAME_LENGTH = 20;

export const REQUESTED_DOCUMENT_UPLOAD_RECEIPT_TOAST = (
  documentName: string,
): string => {
  const displayDocumentName =
    documentName.length > MAX_UPLOAD_RECEIPT_DOCUMENT_NAME_LENGTH
      ? `${documentName.slice(0, MAX_UPLOAD_RECEIPT_DOCUMENT_NAME_LENGTH - 3)}...`
      : documentName;

  return `Thanks - we've received ${displayDocumentName}. The WCG Review Team will take a look.`;
};

/** Failure copy after an external user's requested-document upload is rejected. */
export const REQUESTED_DOCUMENT_UPLOAD_FAILURE_TOAST_MESSAGE =
  'The following file(s) were not accepted.  Please upload a different file. : ';
